import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { Table } from '../../../elements/table';
import { PageBody } from '../../../elements/page-body';
import { useDrawer } from '../../../shared/drawer';
import { AreaAssignmentForm } from './area-assignment-form';

export const SaleRepresentatives = () => {
    const { t } = useTranslation();
    const { api, state } = useHttpClient();
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);
    const [areas, setAreas] = useState<any[]>([]);

    useEffect(() => {
        api('/fleet/areas/', 'GET');
    }, []);

    useEffect(() => {
        if (state.data && state.path?.includes('/fleet/areas/') && state.method === 'GET') {
            if (Array.isArray(state.data.results)) {
                setAreas(state.data.results);
            }
        }
    }, [state]);

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };

    const handleAddCommercial = () => {
        open(
            t('common.form-title.new'),
            <AreaAssignmentForm close={handleClose} />
        );
    };

    return (
        <PageBody
            title={'common.label.sale-representatives'}
            newAction={handleAddCommercial}
            newActionTitle={'common.form-title.new'}
        >
            <Table
                path="/fleet/drivers/"
                storePath="sale-representatives"
                query={new URLSearchParams({ is_commercial: 'true' })}
                withPagination
                noDelete
                refresh={refresh}
                Form={AreaAssignmentForm}
                headers={[
                    {
                        key: 'full_name',
                        label: 'common.label.nombre'
                    },
                    {
                        key: 'areas',
                        label: 'common.label.area',
                        render: (value: any, item: any) => (
                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                (Array.isArray(item?.areas) ? item.areas.length > 0 : !!item?.area)
                                    ? 'bg-green-100 text-green-800'
                                    : 'bg-gray-100 text-gray-800'
                            }`}>
                                {Array.isArray(item?.areas)
                                    ? (item.areas.length > 0 ? item.areas.map((a: any) => a?.name).filter(Boolean).join(', ') : '-')
                                    : item?.area?.name || '-'}
                            </span>
                        )
                    }
                ]}
            />
        </PageBody>
    );
};
